export default __webpack_public_path__ + "8f2eb049a3a1f0ed8b2fdca1f3792f65.svg";